// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  rowId: __t.u64().primaryKey().name("row_id"),
  matchId: __t.string().name("match_id"),
  armyIndex: __t.u32().name("army_index"),
  team: __t.u32(),
  name: __t.string(),
  claimedPlayerId: __t.string().name("claimed_player_id"),
  playerId: __t.option(__t.string()).name("player_id"),
  playerName: __t.string().name("player_name"),
  color: __t.string(),
  culture: __t.string(),
  persistentArmyId: __t.option(__t.string()).name("persistent_army_id"),
  rosterSelected: __t.bool().name("roster_selected"),
  deployed: __t.bool(),
  ready: __t.bool(),
  defeated: __t.bool(),
  commanderId: __t.option(__t.string()).name("commander_id"),
  generalId: __t.option(__t.string()).name("general_id"),
  followActive: __t.bool().name("follow_active"),
  followPathJson: __t.string().name("follow_path_json"),
  followSpeed: __t.f64().name("follow_speed"),
  followPathTotalDist: __t.f64().name("follow_path_total_dist"),
  marchOrderJson: __t.string().name("march_order_json"),
  isBot: __t.bool().name("is_bot"),
});
